module.exports = __webpack_public_path__ + "img/schneider.b6b16203.svg";